import { DEPENDENCIES_BY_PLUGIN } from '../../../config';
import { PluginDto } from '../../../api';
import { PluginEntity } from '../../../domain';
import { castViewPropertyToDomain } from '../../api';

export function toDomainPlugin(plugin: PluginDto): PluginEntity {
    return {
        ...plugin,
        traits: plugin.traits.map(castViewPropertyToDomain),
        dependencies: DEPENDENCIES_BY_PLUGIN[plugin.id] ?? [],
    };
}
